import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

/**
 * MagneticButton, subtly pulls toward the cursor on hover.
 * Wraps a Link/button/anchor as its child.
 */
export function MagneticButton({ children, className = "", strength = 22, ...rest }) {
  const ref = useRef(null);
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const sx = useSpring(mx, { stiffness: 200, damping: 18, mass: 0.35 });
  const sy = useSpring(my, { stiffness: 200, damping: 18, mass: 0.35 });
  const x = useTransform(sx, (v) => v);
  const y = useTransform(sy, (v) => v);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const relX = e.clientX - (r.left + r.width / 2);
    const relY = e.clientY - (r.top + r.height / 2);
    mx.set((relX / r.width) * strength);
    my.set((relY / r.height) * strength);
  };
  const reset = () => {
    mx.set(0);
    my.set(0);
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={reset}
      style={{ x, y }}
      className={`inline-block ${className}`}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export default MagneticButton;
